import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/movies';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://www.qiuxiayy.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.qiuxiayy.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://www.qiuxiayy.com',
    description: siteInfo.description,
    email: siteInfo.email,
    foundingDate: siteInfo.founded,
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 免费在线观影平台`,
    description: siteInfo.description,
    url: 'https://www.qiuxiayy.com',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://www.qiuxiayy.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.qiuxiayy.com',
        },
      ],
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedMovies />
          <CategoryGrid />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}